<h1 class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-5">Accounts</h1>

<div>
  <!-- Loading -->
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading"></mat-progress-spinner>

  <!-- Accounts -->
  <div class="ag-grid-container">
    <ag-grid-angular #agGrid class="ag-theme-alpine ag-grid" [gridOptions]="gridOptions">
    </ag-grid-angular>
  </div>
  <!-- Create Environment, Delete Account, Create DevOps Action -->
  <div class="button-div">
    <button class="button-action" mat-raised-button color="primary" (click)="openCreateEnvironment()"
      [disabled]="canCreateEnvironment()">
      <mat-icon>open_in_new</mat-icon>
      Create Environment
    </button>
    <button class="button-action" mat-raised-button color="warn" class="button-action" (click)="deleteAccount()"
      [disabled]="isDeleteAccountDisabled()">
      <mat-icon>delete_forever</mat-icon>
      Delete Account
    </button>
    <!-- Schedule DevOps Action-->
    <mat-form-field class="button-action">
      <mat-label>Action Name</mat-label>
      <mat-select [(ngModel)]="selectedDevOpsAction" name="actionName">
        <mat-option *ngFor="let item of devOpsActions" [value]="item" [disabled]="!item.isEnabled">
          <span>{{item.actionName}}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button class="button-action" mat-raised-button color="primary" (click)="openCreateDevOpsAction()"
      [disabled]="canCreateDevOpsAction()">
      <mat-icon>open_in_new</mat-icon>
      Create DevOps Action
    </button>
  </div>

  <!-- Selected account -->
  <div *ngIf="selectedAccount">
    <p>
      <strong>Account Id: </strong>
      <a [routerLink]="['/erm/accounts', selectedAccount.accountId]">{{selectedAccount.accountId}}</a>
    </p>
    <pre>{{selectedAccount | json}}</pre>
  </div>
</div>